module.exports = __webpack_public_path__ + "static/media/autherror.5be30d40.svg";